export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 19 19" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="MM100-V1.2版本" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="MM100众筹详情-RV" transform="translate(-1063.000000, -1142.000000)" fillRule="nonzero">
                    <g id="编组-30" transform="translate(825.000000, 1131.000000)">
                        <g id="编组-29" transform="translate(15.715976, 10.300000)">
                            <g id="椭圆形-2" transform="translate(224.000000, 2.562745)">
                                <path
                                    d="M7.98816568,0 C12.3999079,0 15.9763314,3.59927946 15.9763314,8.03921569 C15.9763314,12.4791519 12.3999079,16.0784314 7.98816568,16.0784314 C3.5764235,16.0784314 0,12.4791519 0,8.03921569 C0,3.59927946 3.5764235,0 7.98816568,0 Z"
                                    id="路径"
                                    stroke={props.color || '#000000'}
                                    strokeWidth="2"
                                ></path>
                                <path
                                    d="M6.26327048,4.38502674 C6.01270084,4.38502674 5.80957504,4.5894512 5.80957504,4.84162161 L5.80957504,4.84162161 L5.80957504,11.236745 C5.80957504,11.3209971 5.83273801,11.4036065 5.87650147,11.4754302 C6.00748697,11.6904018 6.28683361,11.7578077 6.50043977,11.6259855 L6.50043977,11.6259855 L11.6818123,8.42842385 C11.7427708,8.39080454 11.7940312,8.33921699 11.831412,8.27786853 C11.9623966,8.06289691 11.8954194,7.78176496 11.6818123,7.64994273 L11.6818123,7.64994273 L6.50043977,4.45238106 C6.42907257,4.40833819 6.34698727,4.38502674 6.26327048,4.38502674 Z"
                                    id="路径"
                                    fill={props.color || '#000000'}
                                ></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
